import type { UserItemType } from '@src/store/dashboardTemp/@types';

export const sharedUsersTemp: UserItemType[] = [
    {
        id: 0,
        name: 'Полікарпов Д.П.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 1,
        name: 'Новікова Є.У.',
        isShared: true,
        hasRight: false,
    },
    {
        id: 2,
        name: 'Васильчук Є.Л.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 3,
        name: 'Войтенко Н.П.',
        isShared: false,
        hasRight: false,
    },
    {
        id: 4,
        name: 'Васильєв І.К.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 5,
        name: 'Шпак Я.В.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 6,
        name: 'Полікарпов Д.П.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 7,
        name: 'Новікова Є.У.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 8,
        name: 'Васильчук Є.Л.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 9,
        name: 'Войтенко Н.П.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 10,
        name: 'Васильєв І.К.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 11,
        name: 'Шпак Я.В.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 12,
        name: 'Полікарпов Д.П.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 13,
        name: 'Новікова Є.У.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 14,
        name: 'Васильчук Є.Л.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 15,
        name: 'Войтенко Н.П.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 16,
        name: 'Васильєв І.К.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 17,
        name: 'Шпак Я.В.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 18,
        name: 'Полікарпов Д.П.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 19,
        name: 'Новікова Є.У.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 20,
        name: 'Васильчук Є.Л.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 21,
        name: 'Войтенко Н.П.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 22,
        name: 'Васильєв І.К.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 23,
        name: 'Шпак Я.В.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 24,
        name: 'Полікарпов Д.П.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 25,
        name: 'Новікова Є.У.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 26,
        name: 'Васильчук Є.Л.',
        isShared: true,
        hasRight: true,
    },
    {
        id: 27,
        name: 'Войтенко Н.П.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 28,
        name: 'Васильєв І.К.',
        isShared: false,
        hasRight: true,
    },
    {
        id: 29,
        name: 'Шпак Я.В.',
        isShared: true,
        hasRight: true,
    },
];
